<template>
  <div class="fullcalendar">
    <div class="months-select">
      <p class="month-pre" @click="weekPre()" style="cursor: pointer">
        <i class="el-icon-arrow-left"></i>
        {{ "上一周" }}
      </p>
      <el-date-picker
        :clearable="false"
        size="mini"
        style="width: 100px"
        v-model="curYear"
        @change="changeYear"
        type="year"
        value-format="yyyy"
        placeholder="选择年"
      ></el-date-picker>
      <el-select
        v-model="curMonth"
        size="mini"
        style="width: 90px; margin: 0 10px"
        @change="changeMonth"
      >
        <el-option v-for="(item, index) in months" :label="item + '月'" :value="item" :key="index" />
      </el-select>
      <p class="month-pre" @click="weekNext()" style="cursor: pointer" >
        {{ "下一周 " }}
        <i class="el-icon-arrow-right"></i>
      </p>
    </div>
    <div class="month-table">
      <div class="month-th" :style="{ background: thBgColor, height: thHeight }">
        <div style="flex: 1"></div>
        <div v-for="item in week" :key="item.index" class="days">
          <div
            :style="{
              fontSize: '14px',
              color: item.today == item.dateString ? '#4d6fff' : '#333',
            }"
          >{{ item.title }}</div>
          <div
            :style="{
              fontSize: '12px',
              color: item.today == item.dateString ? '#4d6fff' : '#999',
            }"
          >{{ item.dateString }}</div>
        </div>
      </div>

      <div class="month-tr" v-for="(item, idx) in trNum" :key="item + idx">
        <div
          class="month-td"
          :style="{color: '#333', flex: 1 }"
        >{{ item.time }}</div>
        <div
          v-for="(items, index) in week"
          :key="items.index"
          class="month-td"
          :style="{
            position: 'relative',
            height: rowHeight + 'px',
            borderRight: index === 7 ? 'border-right:1px solid #f5f5f5' : '',
          }"
        >
        <div v-for="(it,itIndex) in items.appointList" :key="it + itIndex">
            <div
              v-if="showContent(it,items,item)"
              :style="{
              position: 'absolute',
              width: '100%',
              height: it.hours * rowHeight + 'px',
              backgroundColor: items.bgColor,
              display: 'flex',
              flexFlow: 'column',
              justifyContent: 'center',
              transform: it.appointmentStartDate.substring(14) === '30' ? 'translate(0px,35px)' : 'translate(0px,0px)',
              }"
            >
              <div @click="showDetail(it)" :style="{cursor: 'pointer'}">
                <div>{{it.appointStartTime}}~{{it.appointEndTime}}(已预约)</div>
                <!-- <div>{{it.photographyMethod == 1 ? '云现场' : '现场'}}:&nbsp;{{it.orderCode}}({{it.addName}})</div> -->
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { getAppointmentRecord } from "@/api/request";
export default {
  components: {},
  data() {
    return {
      moment,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      curMonth: 1, //当前选中的月份,
      curYear: "",
      startDate: "",
      endDate: "",
      week: this.weeks,
      equipmentId: null,
      fulldata: [],
      datas: []
    };
  },
  props: {
    thBgColor: {
      type: String,
      default: "rgba(24, 144, 255, 0.1)"
    },
    type: {
      type: String,
      default: ""
    },
    thHeight: {
      type: String,
      default: "50px"
    },
    isShowYear: {
      type: Boolean,
      default: false
    },
    isShowMonth: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showWeek: {
      type: Boolean,
      default: true
    },
    weeks: {
      type: Array,
      default: () => [
        { title: "周一", date: "", bgColor: "#F0F9EB" },
        { title: "周二", date: "", bgColor: "#F4F4F5" },
        { title: "周三", date: "", bgColor: "#F7FBFF" },
        { title: "周四", date: "", bgColor: "#F0FFF6" },
        { title: "周五", date: "", bgColor: "#FFFCF9" },
        { title: "周六", date: "", bgColor: "#FEF0F0" },
        { title: "周日", date: "", bgColor: "#F8F8F8" }
      ]
    },
    rowHeight: {
      type: Number,
      default: 70
    },
    trNum: {
      type: Array,
      default: () => [
        { time: "" },
        { time: "00:00" },
        { time: "01:00" },
        { time: "02:00" },
        { time: "03:00" },
        { time: "04:00" },
        { time: "05:00" },
        { time: "06:00" },
        { time: "07:00" },
        { time: "08:00" },
        { time: "09:00" },
        { time: "10:00" },
        { time: "11:00" },
        { time: "12:00" },
        { time: "13:00" },
        { time: "14:00" },
        { time: "15:00" },
        { time: "16:00" },
        { time: "17:00" },
        { time: "18:00" },
        { time: "19:00" },
        { time: "20:00" },
        { time: "21:00" },
        { time: "22:00" },
        { time: "23:00" }
      ]
    }
  },
  mounted() {
    // this.getWeeks();
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.fulldata = newValue;
        this.week = this.weeks.map((item, index) => {
            // 循环
            return {
              ...item,
              date: moment(this.startDate)
                .subtract(-index, "days")
                .format("YYYY-MM-DD"),
              dateString: moment(this.startDate)
                .subtract(-index, "days")
                .format("MM/DD"),
              today: moment().format("MM/DD")
            };
          }).map(item => {
            let row = {};
            row = this.fulldata.filter(res => {
              return res.appointDate === item.date;
            });
            row.map(i => {
              let hours =
                (moment(i.appointmentEndDate).valueOf() -
                  moment(i.appointmentStartDate).valueOf()) /
                3600 /
                1000;
              i.hours = hours;
            });
            return { ...item, appointList: row };
          });
      },
      deep: true
    }
  },
  methods: {
    getList(equipmentId) {
      this.equipmentId = equipmentId
      this.datas = []
      let params = {
        equipmentId: equipmentId,
        queryStartDate: this.startDate,
        queryEndDate: this.endDate
      };
      getAppointmentRecord(params).then(res => {
        this.datas = res.data;
      });
    },
    showContent(it, items, item) {
      let startDateFormat = moment(it.appointmentStartDate).format("YYYY-MM-DD");
      let dateFormat = moment(items.date).format("YYYY-MM-DD");
      let startValue = moment(it.appointmentStartDate).valueOf();
      let endValue = moment(it.appointmentEndDate).valueOf();
      let dateStartValue = moment(items.date.substring(0, 10) + " " + item.time).startOf("hours").valueOf();
      let dateEndValue = moment(items.date.substring(0, 10) + " " + item.time).endOf("hours").valueOf();
      //如果开始时间在30分，需要替换成00，样式已做了往下处理
      let appointmentStartDate = ''
      if (it.appointmentStartDate.substring(14) === '30') {
        appointmentStartDate  = moment(it.appointmentStartDate).format('HH:00')
      } else {
        appointmentStartDate  = moment(it.appointmentStartDate).format('HH:mm')
      }
      if (
        appointmentStartDate == item.time &&
        startDateFormat === dateFormat &&
        endValue >= dateEndValue
      ) {
        return true;
      } else {
        return false;
      }
    },
    getWeeks(id,date) {
      this.equipmentId = id
      this.startDate = moment(date)
        .weekday(1)
        .format("YYYY-MM-DD"); // 这周的第一天
      this.endDate = moment(date)
        .weekday(7)
        .format("YYYY-MM-DD"); // 这周的最后一天
      this.curMonth = moment(this.endDate).format("M" + "月");
      this.curYear = moment(this.endDate).format("yyyy");
      this.getList(this.equipmentId);
      this.week = this.week.map((it, d) => {
        return {
          ...it,
          date: moment(date)
            .startOf("weeks")
            .add(d, "days")
            .format("YYYY-MM-DD HH:ss")
        };
      });
    },
    showDetail(row) {
      this.$emit("showDetail", row);
    },
    changeYear(val) {
      let month = moment(this.startDate).format("MM");
      let date = val + "-" + month;
      this.getWeeks(this.equipmentId,date);
    },
    changeMonth(val) {
      let year = this.isShowYear
        ? this.curYear
        : moment(this.startDate).format("YYYY");
      // let day = moment(this.startDate).format("DD");
      let date = "";
      if (val < 10) {
        date = year + "-0" + val + "-01";
      } else {
        date = year + "-" + val + "-01";
      }
      this.getWeeks(this.equipmentId,date);
    },
    // 上一周
    weekPre() {
      let lastDate = moment(this.startDate)
        .weekday(-7)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.getWeeks(this.equipmentId,lastDate);
    },
    // 下一周
    weekNext() {
      let nextDate = moment(this.startDate)
        .weekday(7)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.getWeeks(this.equipmentId,nextDate);
    }
  }
};
</script>
<style scoped>
.fullcalendar {
  background: #fff;
}
.month-table {
  margin-top: 5px;
}
.months-select {
  display: flex;
  align-items: center;
  position: absolute;
  top: 30px;
  left: 40px;
  height: 50px;
  z-index: 2010;
}
.month-pre {
  font-size: 14px;
  margin-right: 10px;
}
.month-th {
  /* height: 46px; */
  display: flex;
}
.days {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.month-tr {
  display: flex;
  font-size: 13px;
}
.month-td {
  flex: 1;
  /* justify-content: center; */
  display: flex;
  border-left: 1px solid #f8f8f8;
  border-bottom: 1px solid #f8f8f8;
  position: relative;
}
.current-bg {
  width: 100%;
  height: inherit;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 3px;
}
.current-height {
  position: absolute;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
  overflow-y: scroll;
  /* align-items: center; */
  z-index: 3;
  padding: 5px 10px;
}
.curDot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 20px;
}
</style>
